module.exports = __webpack_public_path__ + "static/media/close.6ec95248.png";